module.exports = __webpack_public_path__ + "img/c02_unitmerchanttransport_Normal_ua.9ae81a23.webp";